module.exports = __webpack_public_path__ + "img/Toyota-2019-Tacoma-2.10f72442.png";